(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/adobe-target-payload-handler/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/components/adobe-target-payload-handler/assets/javascripts/prescript.js'); 
svs = svs || {};
svs.components = svs.components || {};
svs.components.adobeTargetPayloadHandler = svs.components.adobeTargetPayloadHandler || {};
svs.components.adobeTargetPayloadHandler.helpers = svs.components.adobeTargetPayloadHandler.helpers || {};

 })(window);